// SPDX-License-Identifier: FSL-1.1-Apache-2.0
/**
 * @module cn
 * @package @geenius/analytics/react
 * @description Provides the Tailwind-aware className composition helper used
 * by the React analytics variant. The helper combines `clsx` with
 * `tailwind-merge` so authored utility-class contracts remain deterministic.
 */

import clsx from "clsx";
import { twMerge } from "tailwind-merge";

type ClassValue = Parameters<typeof clsx>[number];

/**
 * Merges conditional class fragments into a single Tailwind-safe className.
 *
 * @param inputs Conditional class fragments, objects, arrays, and other clsx-compatible values.
 * @returns A merged class string with conflicting Tailwind utilities deduplicated.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
